import dayjs from "dayjs";

// =====================
// Data & Duration
// =====================
export const duration = {
  startDate: dayjs("2025-10-01").toDate(),
  endDate: dayjs().toDate(),
  dates: [],
};

const names = [
  "Aarav Sharma",
  "Vivaan Kapoor",
  "Aditya Verma",
  "Yashraj Singh",
  "Kunal Mehta",
  "Arjun Bansal",
  "Rohan Khurana",
  "Pranav Desai",
  "Kartik Reddy",
  "Nikhil Nair",
  "Pooja Naik",
  "Shalini Roy",
  "Megha Sinha",
  "Nandini Das",
  "Vishal Saini",
  "Sumit Rawat",
  "Narendra Jaiswal",
  "Abhishek Kashyap",
  "Tushar Suri",
  "Mitesh Shah",
  "Hardik Doshi",
  "Jignesh Panchal",
  "Ronit Vyas",
  "Vivek Kadam",
  "Ritesh Kulkarni",
  "Sagar Patil",
  "Omkar Sahu",
  "Shreyas Hegde",
  "Siddharth Jain",
  "Harsh Vardhan",
  "Deepak Chauhan",
  "Ritesh Thakur",
  "Mahesh Lokhande",
  "Suraj Wagh",
  "Ravindra Salve",
  "Vikram More",
  "Parthiban Murthy",
  "Sathish Kumar",
  "Jagadeesh Pillai",
  "Sudarshan Reddy",
  "Mohan Swamy",
  "Kishore Prasad",
  "Tanmay Joshi",
  "Hrithik Pandey",
  "Ayush Tiwari",
  "Devansh Chawla",
  "Amitabh Soni",
  "Rahul Bhat",
  "Karthik Srinivas",
  "Bharat Rao",
  "Gopal Tripathi",
  "Lokesh Suryavanshi",
  "Rajdeep Bhattacharya",
  "Arnab Chakraborty",
  "Debasis Das",
  "Subham Ghosh",
  "Prasenjit Paul",
  "Rekha Chouhan",
  "Payal Jha",
  "Divya Narayan",
  "Manish Gautam",
  "Nishant Bhardwaj",
  "Aisha Khan",
  "Ananya Iyer",
  "Priya Menon",
  "Radhika Pillai",
  "Sneha Gupta",
  "Kavya Deshmukh",
  "Saloni Chaturvedi",
  "Deepika Raghavan",
  "Harini Venkatesh",
  "Shruti Agarwal",
  "Preeti Dubey",
  "Lakshmi Krishnan",
  "Nisha Talreja",
  "Anjali Bagchi",
  "Sushmita Rao",
  "Geeta Yadav",
  "Rhea Malhotra",
  "Anushka Rane",
  "Aparna Kulkarni",
  "Sania Mirza",
  "Rituparna Sen",
  "Sukanya Mukherjee",
  "Jayesh Parmar",
  "Rakesh Mahajan",
  "Tarun Chopra",
  "Ashwin Shetty",
  "Varun Gokhale",
  "Hemant Mishra",
  "Ishaan Talwar",
  "Dhruv Malhotra",
];

// =====================
// Random Company Generator
// =====================

function stableHashToUnit(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return (hash % 10000) / 10000;
}

function seededInt(seed, min, max) {
  const u = stableHashToUnit(seed);
  return min + Math.floor(u * (max - min + 1));
}

function seededPick(seed, list) {
  if (!Array.isArray(list) || list.length === 0) return null;
  return list[seededInt(seed, 0, list.length - 1)];
}

const companyPrefixes = [
  "North",
  "South",
  "East",
  "West",
  "Blue",
  "Green",
  "Red",
  "Silver",
  "Golden",
  "Prime",
  "Vertex",
  "Summit",
  "Pioneer",
  "Apex",
  "Nimbus",
  "Nova",
  "Orbit",
  "Quantum",
  "Fusion",
  "Zenith",
  "Aurora",
  "Cascade",
  "Cedar",
  "Cobalt",
  "Crown",
  "Harbor",
  "Horizon",
  "Iron",
  "Maple",
  "Oak",
  "Pebble",
  "Rocket",
  "Saffron",
  "Sierra",
  "Skyline",
  "Stone",
  "Sunrise",
  "Timber",
  "Union",
  "Violet",
  "Willow",
];

const companyRoots = [
  "Systems",
  "Solutions",
  "Technologies",
  "Networks",
  "Digital",
  "Software",
  "Analytics",
  "Dynamics",
  "Platforms",
  "Ventures",
  "Holdings",
  "Logistics",
  "Security",
  "Consulting",
  "Engineering",
  "Industries",
  "Labs",
  "Studios",
  "Works",
  "Capital",
  "Partners",
  "Health",
  "Energy",
  "Retail",
  "Media",
  "Finance",
  "Cloud",
  "Data",
  "AI",
  "Mobile",
];

const companySuffixes = [
  "Group",
  "Labs",
  "Systems",
  "Solutions",
  "Tech",
  "Works",
  "Partners",
  "Ventures",
  "Studios",
  "Networks",
  "Digital",
];

const companyLegal = ["Inc", "LLC", "Ltd", "Corp"];

function generateCompanyName(seed) {
  const prefix = seededPick(`${seed}|prefix`, companyPrefixes);
  const root = seededPick(`${seed}|root`, companyRoots);
  const suffix = seededPick(`${seed}|suffix`, companySuffixes);
  const includeLegal = stableHashToUnit(`${seed}|legal`) < 0.35;
  const legal = includeLegal
    ? seededPick(`${seed}|legalPick`, companyLegal)
    : "";

  const pattern = seededInt(`${seed}|pattern`, 1, 4);
  const base =
    pattern === 1
      ? `${prefix} ${root}`
      : pattern === 2
        ? `${root} ${suffix}`
        : pattern === 3
          ? `${prefix} ${root} ${suffix}`
          : `${root}`;

  return legal ? `${base} ${legal}` : base;
}

function createCompany(index, usedNames) {
  const id = `comp_${index}`;
  let attempt = 0;
  let name = "";
  while (attempt < 50) {
    const seed = `company|${id}|name|${attempt}`;
    const next = generateCompanyName(seed);
    if (!usedNames || !usedNames.has(next)) {
      name = next;
      if (usedNames) usedNames.add(next);
      break;
    }
    attempt++;
  }
  if (!name) name = generateCompanyName(`company|${id}|fallback`);
  return { id, name };
}

const jobLevels = [
  "Junior",
  "Mid-Level",
  "Senior",
  "Lead",
  "Principal",
  "Staff",
];

const jobDomains = [
  "Frontend",
  "Backend",
  "Full Stack",
  "Mobile",
  "DevOps",
  "Data",
  "AI/ML",
  "Cloud",
  "Security",
  "QA",
  "Product",
  "Design",
];

const jobRoles = [
  "Software Engineer",
  "Developer",
  "Engineer",
  "Analyst",
  "Architect",
  "Manager",
  "Consultant",
  "Specialist",
];

const jobFocus = [
  "React",
  "Node.js",
  "Python",
  "Java",
  "Golang",
  "AWS",
  "Azure",
  "Kubernetes",
  "Data Platform",
  "Automation",
  "Platform",
  "SRE",
];

function pickRandom(list) {
  return list[Math.floor(Math.random() * list.length)];
}

function generateJobTitle() {
  const level = pickRandom(jobLevels);
  const domain = pickRandom(jobDomains);
  const role = pickRandom(jobRoles);
  const focus = pickRandom(jobFocus);

  const patterns = [
    () => `${level} ${domain} ${role}`,
    () => `${domain} ${role}`,
    () => `${level} ${role}`,
    () => `${level} ${focus} ${role}`,
    () => `${domain} ${focus} ${role}`,
  ];

  return patterns[Math.floor(Math.random() * patterns.length)]();
}

let jobCounter = 1;

function createJobTitle() {
  return generateJobTitle();
}

function createJob(jobOpenDate, companyId, companyName, bdmId) {
  return {
    jobId: `job_${jobCounter++}`,
    jobTitle: createJobTitle(),
    companyId,
    companyName,
    bdmId,
    jobOpenDate,
    jobStatus: "open",
    jobClosedAt: null,
    jobCloseReason: null,
  };
}

// =====================
// Employees Generator
// =====================

const numOfEmployees = 10;
const employees = [];

for (let i = 0; i < numOfEmployees; i++) {
  const name = names[Math.floor(Math.random() * names.length)];

  const start = dayjs(duration.startDate);
  const end = dayjs(duration.endDate);

  const joinDate = start.add(
    Math.floor(Math.random() * end.diff(start, "day")),
    "day",
  );

  const isStillWorking = Math.random() < 0.85;

  let lastDateIfWorking = null;

  if (!isStillWorking) {
    lastDateIfWorking = joinDate
      .add(Math.floor(Math.random() * end.diff(joinDate, "day")), "day")
      .toDate();
  }

  employees.push({
    id: i + 1,
    name,
    dateOfJoining: joinDate.toDate(),
    lastDateIfWorking,
  });
}

// =====================
// Submission Pipeline
// =====================

const submissionStages = [
  { id: 1, name: "Internal Submission" },
  { id: 2, name: "Client Submissions" },
  { id: 3, name: "Interview Round 1" },
  { id: 4, name: "Interview Round 2" },
  { id: 5, name: "Interview Round 3" },
  { id: 6, name: "Placed" },
];

let candidateCounter = 1;

function createCandidateIds(n) {
  const ids = [];

  for (let i = 0; i < n; i++) {
    ids.push(`cand_${candidateCounter++}`);
  }

  return ids;
}

function runPipeline(stages) {
  const firstStageCandidates = createCandidateIds(
    Math.floor(Math.random() * 5) + 3,
  );

  let currentCandidates = firstStageCandidates;
  const stagesResult = [];

  for (const stage of stages) {
    if (currentCandidates.length === 0) break;

    const approved = [];
    const rejected = [];

    currentCandidates.forEach((id) => {
      if (Math.random() < 0.65) {
        approved.push(id);
      } else {
        rejected.push(id);
      }
    });

    stagesResult.push({
      stage: stage.name,
      approved: { candidateIds: approved },
      rejected: { candidateIds: rejected },
    });

    currentCandidates = approved;
  }

  return stagesResult;
}

// =====================
// Date-wise Generator
// =====================

export function generateAtsDataset(employees, stages) {
  const startDate = dayjs(duration.startDate).startOf("day");
  const endDate = dayjs(duration.endDate).startOf("day");
  const stageNamesRaw = (stages || []).map((s) => s?.name).filter(Boolean);
  const stageNames = Array.from(new Set(stageNamesRaw));
  if (!stageNames.includes("Placed")) stageNames.push("Placed");
  const placedIndex = stageNames.indexOf("Placed");
  if (placedIndex !== stageNames.length - 1) {
    stageNames.splice(placedIndex, 1);
    stageNames.push("Placed");
  }

  function randInt(seed, min, max) {
    const u = stableHashToUnit(seed);
    return min + Math.floor(u * (max - min + 1));
  }

  function randChance(seed, p) {
    return stableHashToUnit(seed) < p;
  }

  function addDays(d, days) {
    return dayjs(d).add(days, "day").toDate();
  }

  function startOfDay(d) {
    return dayjs(d).startOf("day").toDate();
  }

  function addWorkdays(d, workdays) {
    let cursor = dayjs(d).startOf("day");
    let added = 0;
    while (added < workdays) {
      cursor = cursor.add(1, "day");
      const dow = cursor.day();
      if (dow !== 0 && dow !== 6) added++;
    }
    return cursor.toDate();
  }

  function seededJobTitle(seed) {
    const level = seededPick(`${seed}|level`, jobLevels);
    const domain = seededPick(`${seed}|domain`, jobDomains);
    const role = seededPick(`${seed}|role`, jobRoles);
    const focus = seededPick(`${seed}|focus`, jobFocus);
    const pattern = seededInt(`${seed}|pattern`, 1, 5);
    if (pattern === 1) return `${level} ${domain} ${role}`;
    if (pattern === 2) return `${domain} ${role}`;
    if (pattern === 3) return `${level} ${role}`;
    if (pattern === 4) return `${level} ${focus} ${role}`;
    return `${domain} ${focus} ${role}`;
  }

  const workdays = [];
  let workCursor = startDate.clone();
  while (workCursor.isBefore(endDate) || workCursor.isSame(endDate, "day")) {
    const dow = workCursor.day();
    if (dow !== 0 && dow !== 6) {
      workdays.push({
        key: workCursor.format("YYYY-MM-DD"),
        date: workCursor.toDate(),
      });
    }
    workCursor = workCursor.add(1, "day");
  }

  const COMPANY_POOL_SIZE = 80;
  const POPULAR_COMPANY_COUNT = 18;
  const usedCompanyNames = new Set();
  const companies = Array.from({ length: COMPANY_POOL_SIZE }, (_, i) =>
    createCompany(i + 1, usedCompanyNames),
  );
  const popularCompanies = companies.slice(
    0,
    Math.min(POPULAR_COMPANY_COUNT, companies.length),
  );

  const candidates = Array.from({ length: 360 }, (_, i) => {
    const id = `cand_${i + 1}`;
    const fullName = seededPick(`cand|${id}|name`, names);
    const local = String(fullName || "candidate")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ".")
      .replace(/^\.|\.$/g, "");
    const suffix = String(seededInt(`cand|${id}|emailNum`, 10, 999));
    return {
      id,
      fullName,
      email: `${local}.${suffix}@example.com`,
      phone: `+1-${seededInt(`cand|${id}|p1`, 200, 999)}-${seededInt(
        `cand|${id}|p2`,
        200,
        999,
      )}-${seededInt(`cand|${id}|p3`, 1000, 9999)}`,
      createdAt: startOfDay(
        addDays(startDate.toDate(), seededInt(`cand|${id}|created`, 0, 45)),
      ),
    };
  });

  const bdmCompanies = new Map();
  employees.forEach((emp) => {
    const perBdm = randInt(`bdm|${emp.id}|companies`, 6, 10);
    const picks = [];
    const pickIds = new Set();
    const popularIds = new Set(popularCompanies.map((c) => c.id));
    const maxAttempts = perBdm * 7;
    for (let i = 0; i < maxAttempts && picks.length < perBdm; i++) {
      const usePopular =
        popularCompanies.length > 0 &&
        randChance(`bdm|${emp.id}|comp|${i}|popular`, 0.65);
      const source = usePopular ? popularCompanies : companies;
      const comp =
        source[randInt(`bdm|${emp.id}|comp|${i}`, 0, source.length - 1)];
      if (!comp) continue;
      if (pickIds.has(comp.id)) continue;
      pickIds.add(comp.id);
      picks.push(comp);
    }
    if (picks.length > 0 && !picks.some((c) => popularIds.has(c.id))) {
      const pop =
        popularCompanies[
          randInt(
            `bdm|${emp.id}|comp|forcePopular`,
            0,
            popularCompanies.length - 1,
          )
        ];
      if (pop && !pickIds.has(pop.id)) {
        if (picks.length < perBdm) picks.push(pop);
        else picks[0] = pop;
      }
    }
    if (picks.length === 0 && companies.length > 0) {
      picks.push(
        companies[
          randInt(`bdm|${emp.id}|comp|fallback`, 0, companies.length - 1)
        ],
      );
    }
    bdmCompanies.set(emp.id, picks);
  });

  const jobs = [];
  const applications = [];
  const events = [];
  const jobById = new Map();
  const openJobs = new Set();
  const jobAppliedCandidates = new Map();
  const applicationsById = new Map();
  const jobActiveApps = new Map();
  const actionsByDay = new Map();
  let eventCounter = 1;

  const recordEvent = (evt) => {
    events.push(evt);
  };

  const scheduleAction = (dayKey, applicationId) => {
    if (!actionsByDay.has(dayKey)) actionsByDay.set(dayKey, new Set());
    actionsByDay.get(dayKey).add(applicationId);
  };

  const unscheduleAction = (dayKey, applicationId) => {
    const set = actionsByDay.get(dayKey);
    if (!set) return;
    set.delete(applicationId);
    if (set.size === 0) actionsByDay.delete(dayKey);
  };

  const closeJob = (jobId, at, reason) => {
    const job = jobById.get(jobId);
    if (!job || job.jobStatus !== "open") return;
    const closedAt = startOfDay(at);
    job.jobClosedAt = closedAt;
    job.jobCloseReason = reason;
    job.jobStatus = reason === "filled" ? "filled" : "closed";
    openJobs.delete(jobId);

    const activeSet = jobActiveApps.get(jobId);
    if (!activeSet) return;

    const dayKey = dayjs(closedAt).format("YYYY-MM-DD");
    Array.from(activeSet).forEach((appId) => {
      const app = applicationsById.get(appId);
      if (!app || app.status !== "active") return;
      app.status = "rejected";
      app.rejectedAt = closedAt;
      app.rejectedReason = "job_closed";
      unscheduleAction(app.nextActionDayKey, appId);
      activeSet.delete(appId);

      recordEvent({
        eventId: `evt_${eventCounter++}`,
        at: closedAt,
        type: "rejected",
        stage:
          stageNames[
            Math.max(0, Math.min(app.stageIndex, stageNames.length - 1))
          ],
        jobId,
        applicationId: appId,
        candidateId: app.candidateId,
      });
    });
  };

  workdays.forEach((wd) => {
    const dayKey = wd.key;
    const dayDate = startOfDay(wd.date);

    employees.forEach((emp) => {
      const openToday = randChance(`job|open|${emp.id}|${dayKey}`, 0.45);
      if (!openToday) return;

      const openCount = randInt(`job|openCount|${emp.id}|${dayKey}`, 1, 2);
      const companyList = bdmCompanies.get(emp.id) || companies;
      for (let ji = 0; ji < openCount; ji++) {
        const useGlobal =
          companies.length > 0 &&
          randChance(`job|${emp.id}|${dayKey}|${ji}|globalComp`, 0.12);
        const source = useGlobal ? companies : companyList;
        const company =
          source[
            randInt(`job|${emp.id}|${dayKey}|${ji}|comp`, 0, source.length - 1)
          ] ||
          companies[0] ||
          companyList[0];
        if (!company) continue;

        const job = createJob(dayDate, company.id, company.name, emp.id);
        job.jobTitle = seededJobTitle(`job|${emp.id}|${dayKey}|${ji}|title`);
        job.vacanciesTotal = randInt(`job|${job.jobId}|vacanciesTotal`, 1, 3);
        job.vacanciesFilled = 0;
        job.closingGraceUsed = false;
        const ttl = randInt(`job|${job.jobId}|ttl`, 18, 35);
        const targetClose = addWorkdays(dayDate, ttl);
        job.targetCloseAt =
          targetClose > endDate.toDate() ? endDate.toDate() : targetClose;

        jobs.push(job);
        jobById.set(job.jobId, job);
        openJobs.add(job.jobId);
      }
    });

    Array.from(openJobs).forEach((jobId) => {
      const job = jobById.get(jobId);
      if (!job) return;
      if (dayDate < startOfDay(job.jobOpenDate)) return;
      if (job.jobStatus !== "open") return;
      if (job.jobClosedAt && dayDate > startOfDay(job.jobClosedAt)) return;

      const ageDays = Math.max(
        0,
        dayjs(dayDate).diff(dayjs(job.jobOpenDate), "day"),
      );
      const maxNewApps = ageDays <= 3 ? 3 : ageDays <= 10 ? 2 : 1;
      const newApps = randInt(`app|new|${jobId}|${dayKey}`, 0, maxNewApps);
      if (newApps <= 0) return;

      if (!jobAppliedCandidates.has(jobId))
        jobAppliedCandidates.set(jobId, new Set());
      if (!jobActiveApps.has(jobId)) jobActiveApps.set(jobId, new Set());
      const appliedSet = jobAppliedCandidates.get(jobId);
      const activeSet = jobActiveApps.get(jobId);

      for (let ai = 0; ai < newApps; ai++) {
        let candidateId = null;
        for (let attempt = 0; attempt < 18; attempt++) {
          const candIndex = randInt(
            `app|${jobId}|${dayKey}|${ai}|cand|try|${attempt}`,
            0,
            candidates.length - 1,
          );
          const nextId = candidates[candIndex]?.id;
          if (!nextId) continue;
          if (appliedSet.has(nextId)) continue;
          candidateId = nextId;
          break;
        }
        if (!candidateId) continue;
        appliedSet.add(candidateId);

        const applicationId = `app_${jobId}_${candidateId}_${dayKey}`;
        const nextActionAt = addWorkdays(
          dayDate,
          randInt(`app|${applicationId}|next`, 1, 3),
        );
        const nextActionDayKey = dayjs(nextActionAt).format("YYYY-MM-DD");

        const app = {
          applicationId,
          jobId,
          candidateId,
          appliedAt: dayDate,
          status: "active",
          stageIndex: 0,
          nextActionAt: startOfDay(nextActionAt),
          nextActionDayKey,
          rejectedAt: null,
          rejectedReason: null,
          placedAt: null,
        };

        applications.push(app);
        applicationsById.set(applicationId, app);
        activeSet.add(applicationId);
        scheduleAction(nextActionDayKey, applicationId);

        recordEvent({
          eventId: `evt_${eventCounter++}`,
          at: dayDate,
          type: "entered",
          stage: stageNames[0],
          jobId,
          applicationId,
          candidateId,
        });
      }
    });

    const due = actionsByDay.get(dayKey);
    if (due) {
      Array.from(due).forEach((applicationId) => {
        const app = applicationsById.get(applicationId);
        if (!app || app.status !== "active") {
          unscheduleAction(dayKey, applicationId);
          return;
        }
        const job = jobById.get(app.jobId);
        if (!job || job.jobStatus !== "open") {
          app.status = "rejected";
          app.rejectedAt = dayDate;
          app.rejectedReason = "job_closed";
          unscheduleAction(dayKey, applicationId);
          const activeSet = jobActiveApps.get(app.jobId);
          if (activeSet) activeSet.delete(applicationId);
          recordEvent({
            eventId: `evt_${eventCounter++}`,
            at: dayDate,
            type: "rejected",
            stage:
              stageNames[
                Math.max(0, Math.min(app.stageIndex, stageNames.length - 1))
              ],
            jobId: app.jobId,
            applicationId,
            candidateId: app.candidateId,
          });
          return;
        }

        if (job.jobClosedAt && dayDate > startOfDay(job.jobClosedAt)) {
          app.status = "rejected";
          app.rejectedAt = startOfDay(job.jobClosedAt);
          app.rejectedReason = "job_closed";
          unscheduleAction(dayKey, applicationId);
          const activeSet = jobActiveApps.get(app.jobId);
          if (activeSet) activeSet.delete(applicationId);
          recordEvent({
            eventId: `evt_${eventCounter++}`,
            at: startOfDay(job.jobClosedAt),
            type: "rejected",
            stage:
              stageNames[
                Math.max(0, Math.min(app.stageIndex, stageNames.length - 1))
              ],
            jobId: app.jobId,
            applicationId,
            candidateId: app.candidateId,
          });
          return;
        }

        const stageName =
          stageNames[
            Math.max(0, Math.min(app.stageIndex, stageNames.length - 1))
          ];
        if (stageName === "Placed") {
          app.status = "placed";
          app.placedAt = dayDate;
          unscheduleAction(dayKey, applicationId);
          const activeSet = jobActiveApps.get(app.jobId);
          if (activeSet) activeSet.delete(applicationId);
          return;
        }

        const approveBase = 0.72;
        const approveProb = Math.max(0.22, approveBase - app.stageIndex * 0.08);
        const approved = randChance(
          `app|${applicationId}|${stageName}|ok|${dayKey}`,
          approveProb,
        );

        unscheduleAction(dayKey, applicationId);

        if (!approved) {
          app.status = "rejected";
          app.rejectedAt = dayDate;
          app.rejectedReason = "stage_reject";
          const activeSet = jobActiveApps.get(app.jobId);
          if (activeSet) activeSet.delete(applicationId);
          recordEvent({
            eventId: `evt_${eventCounter++}`,
            at: dayDate,
            type: "rejected",
            stage: stageName,
            jobId: app.jobId,
            applicationId,
            candidateId: app.candidateId,
          });
          return;
        }

        const nextStage = stageNames[app.stageIndex + 1];
        if (!nextStage) return;

        if (
          nextStage === "Placed" &&
          job.vacanciesFilled >= job.vacanciesTotal
        ) {
          app.status = "rejected";
          app.rejectedAt = dayDate;
          app.rejectedReason = "no_vacancy";
          const activeSet = jobActiveApps.get(app.jobId);
          if (activeSet) activeSet.delete(applicationId);
          recordEvent({
            eventId: `evt_${eventCounter++}`,
            at: dayDate,
            type: "rejected",
            stage: stageName,
            jobId: app.jobId,
            applicationId,
            candidateId: app.candidateId,
          });
          return;
        }

        recordEvent({
          eventId: `evt_${eventCounter++}`,
          at: dayDate,
          type: "approved",
          stage: stageName,
          jobId: app.jobId,
          applicationId,
          candidateId: app.candidateId,
        });
        recordEvent({
          eventId: `evt_${eventCounter++}`,
          at: dayDate,
          type: "entered",
          stage: nextStage,
          jobId: app.jobId,
          applicationId,
          candidateId: app.candidateId,
        });

        app.stageIndex += 1;

        if (nextStage === "Placed") {
          recordEvent({
            eventId: `evt_${eventCounter++}`,
            at: dayDate,
            type: "approved",
            stage: "Placed",
            jobId: app.jobId,
            applicationId,
            candidateId: app.candidateId,
          });
          app.status = "placed";
          app.placedAt = dayDate;
          job.vacanciesFilled += 1;
          const activeSet = jobActiveApps.get(app.jobId);
          if (activeSet) activeSet.delete(applicationId);
          if (job.vacanciesFilled >= job.vacanciesTotal)
            closeJob(job.jobId, dayDate, "filled");
          return;
        }

        const maxDelay =
          app.stageIndex <= 1
            ? 3
            : app.stageIndex === 2
              ? 5
              : app.stageIndex === 3
                ? 5
                : 4;
        const delay = randInt(
          `app|${applicationId}|${nextStage}|delay|${dayKey}`,
          1,
          maxDelay,
        );
        const nextActionAt = addWorkdays(dayDate, delay);
        const nextActionDayKey = dayjs(nextActionAt).format("YYYY-MM-DD");
        app.nextActionAt = startOfDay(nextActionAt);
        app.nextActionDayKey = nextActionDayKey;
        scheduleAction(nextActionDayKey, applicationId);
      });
    }

    Array.from(openJobs).forEach((jobId) => {
      const job = jobById.get(jobId);
      if (!job || job.jobStatus !== "open") return;
      const target = startOfDay(job.targetCloseAt);
      if (dayDate < target) return;
      if (job.vacanciesFilled >= job.vacanciesTotal) return;
      if (!job.closingGraceUsed) {
        const activeSet = jobActiveApps.get(jobId);
        let hasInterviewingCandidates = false;
        if (activeSet) {
          for (const appId of activeSet) {
            const app = applicationsById.get(appId);
            if (!app || app.status !== "active") continue;
            if (app.stageIndex >= 2) {
              hasInterviewingCandidates = true;
              break;
            }
          }
        }
        if (hasInterviewingCandidates) {
          const extended = addWorkdays(target, 5);
          job.targetCloseAt =
            extended > endDate.toDate() ? endDate.toDate() : extended;
          job.closingGraceUsed = true;
          return;
        }
      }
      closeJob(jobId, dayDate, "cancelled");
    });
  });

  const internalStageName = stageNames?.[0] ?? "Internal Submission";
  const jobsWithAnyEvents = new Set(
    events.map((e) => e?.jobId).filter(Boolean),
  );

  jobs.forEach((job) => {
    if (!job?.jobId) return;
    if (jobsWithAnyEvents.has(job.jobId)) return;
    if (!Array.isArray(candidates) || candidates.length === 0) return;

    const candIndex = randInt(
      `ensure|${job.jobId}|cand`,
      0,
      candidates.length - 1,
    );
    const candidateId = candidates[candIndex]?.id;
    if (!candidateId) return;

    const applicationId = `app_${job.jobId}_${candidateId}_ensure`;
    const openDay = startOfDay(job.jobOpenDate);
    const delay = randInt(`ensure|${job.jobId}|delay`, 2, 8);
    const plannedAt = startOfDay(addWorkdays(openDay, delay));
    const at =
      plannedAt > endDate.toDate() ? startOfDay(endDate.toDate()) : plannedAt;

    applications.push({
      id: applicationId,
      applicationId,
      jobId: job.jobId,
      candidateId,
      status: "active",
      stageIndex: 0,
      createdAt: at,
      nextActionAt: null,
      nextActionDayKey: null,
      placedAt: null,
      rejectedAt: null,
      rejectedReason: null,
    });

    applicationsById.set(applicationId, applications[applications.length - 1]);

    recordEvent({
      eventId: `evt_${eventCounter++}`,
      at,
      type: "entered",
      stage: internalStageName,
      jobId: job.jobId,
      applicationId,
      candidateId,
    });
  });

  return {
    stages: stageNames.map((name, i) => ({
      id: `stage_${i + 1}`,
      name,
      order: i + 1,
    })),
    recruiters: employees.map((e) => ({ id: e.id, name: e.name })),
    companies,
    candidates,
    jobs: jobs.map((j) => ({
      ...j,
      vacanciesTotal: j.vacanciesTotal,
      vacanciesFilled: j.vacanciesFilled,
      targetCloseAt: j.targetCloseAt,
    })),
    applications,
    events,
  };
}

export function generateDateWiseData(employees, stages) {
  const startDate = dayjs(duration.startDate).startOf("day");
  const endDate = dayjs(duration.endDate).startOf("day");
  const result = [];
  const leaveProbabilityMax = 0.2;
  const ats = generateAtsDataset(employees, stages);
  const stageNames = (ats?.stages || []).map((s) => s?.name).filter(Boolean);

  function randInt(seed, min, max) {
    const u = stableHashToUnit(seed);
    return min + Math.floor(u * (max - min + 1));
  }

  function randChance(seed, p) {
    return stableHashToUnit(seed) < p;
  }

  function addDays(d, days) {
    return dayjs(d).add(days, "day").toDate();
  }

  function startOfDay(d) {
    return dayjs(d).startOf("day").toDate();
  }

  const workdays = [];
  let workCursor = startDate.clone();
  while (workCursor.isBefore(endDate) || workCursor.isSame(endDate, "day")) {
    const dow = workCursor.day();
    if (dow !== 0 && dow !== 6) {
      workdays.push({
        key: workCursor.format("YYYY-MM-DD"),
        date: workCursor.toDate(),
      });
    }
    workCursor = workCursor.add(1, "day");
  }

  const jobById = new Map((ats?.jobs || []).map((j) => [j.jobId, j]));
  const jobsByBdm = new Map();
  (ats?.jobs || []).forEach((j) => {
    const key = String(j.bdmId);
    if (!jobsByBdm.has(key)) jobsByBdm.set(key, []);
    jobsByBdm.get(key).push(j.jobId);
  });

  const internalStageName = stageNames?.[0] ?? "Internal Submission";

  const jobStageTimeline = new Map();
  (ats?.events || []).forEach((evt) => {
    if (!evt?.jobId || !evt?.stage || !evt?.candidateId) return;
    if (
      evt.type !== "approved" &&
      evt.type !== "rejected" &&
      evt.type !== "entered"
    )
      return;
    if (evt.type === "entered" && evt.stage !== internalStageName) return;
    const dayKey = dayjs(evt.at).format("YYYY-MM-DD");
    if (!jobStageTimeline.has(evt.jobId))
      jobStageTimeline.set(evt.jobId, new Map());
    const stagesMap = jobStageTimeline.get(evt.jobId);
    if (!stagesMap.has(evt.stage)) stagesMap.set(evt.stage, new Map());
    const datesMap = stagesMap.get(evt.stage);
    if (!datesMap.has(dayKey))
      datesMap.set(dayKey, {
        entered: new Set(),
        approved: new Set(),
        rejected: new Set(),
      });
    const bucket = datesMap.get(dayKey);
    if (evt.type === "entered") bucket.entered.add(evt.candidateId);
    if (evt.type === "approved") bucket.approved.add(evt.candidateId);
    if (evt.type === "rejected") bucket.rejected.add(evt.candidateId);
  });

  function makeStageTimeline(jobId, stageName) {
    const stagesMap = jobStageTimeline.get(jobId);
    const datesMap = stagesMap ? stagesMap.get(stageName) : null;
    if (!datesMap) return [];
    return Array.from(datesMap.entries())
      .map(([dk, v]) => ({
        date: startOfDay(dk),
        entered: Array.from(v?.entered || []),
        approved: Array.from(v?.approved || []),
        rejected: Array.from(v?.rejected || []),
      }))
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  }

  let current = startDate.clone();

  while (current.isBefore(endDate) || current.isSame(endDate, "day")) {
    const dow = current.day();
    if (dow === 0 || dow === 6) {
      current = current.add(1, "day");
      continue;
    }
    const employeesForDay = [];
    const dateKey = current.format("YYYY-MM-DD");

    if (employees.length > 0) {
      const employeesForSelection = employees.slice(0, employees.length);
      const leaveProbability =
        stableHashToUnit(`${dateKey}|leaveProbability`) * leaveProbabilityMax;
      const leaveCount = Math.min(
        employeesForSelection.length,
        Math.max(
          0,
          Math.round(employeesForSelection.length * leaveProbability),
        ),
      );
      const leaveSet = new Set(
        employeesForSelection
          .map((emp) => ({
            id: emp.id,
            score: stableHashToUnit(`${dateKey}|${emp.id}`),
          }))
          .sort((a, b) => a.score - b.score)
          .slice(0, leaveCount)
          .map((x) => x.id),
      );

      employeesForSelection.forEach((emp) => {
        const isOnLeave = leaveSet.has(emp.id);
        if (isOnLeave) return;

        const companies = [];
        const companyMap = new Map();
        const dayDate = current.toDate();

        const relevantJobIds = new Set();
        const bdmJobIds = jobsByBdm.get(String(emp.id)) || [];
        bdmJobIds.forEach((jobId) => {
          const job = jobById.get(jobId);
          if (!job) return;
          const openedOk =
            job.jobOpenDate != null && new Date(job.jobOpenDate) <= dayDate;
          const closedOk =
            job.jobClosedAt == null || new Date(job.jobClosedAt) >= dayDate;
          if (openedOk && closedOk) relevantJobIds.add(jobId);
        });

        if (relevantJobIds.size === 0) return;

        relevantJobIds.forEach((jobId) => {
          const job = jobById.get(jobId);
          if (!job) return;

          const compId =
            job.companyId ?? `comp_${job.companyName || "unknown"}`;
          const compName = job.companyName ?? String(compId);

          if (!companyMap.has(compId)) {
            companyMap.set(compId, {
              _id: compId,
              id: compId,
              name: compName,
              openJobs: [],
            });
          }

          const jobStages = stageNames.map((n) => ({
            stage: n,
            dates: makeStageTimeline(job.jobId, n),
          }));

          companyMap.get(compId).openJobs.push({
            jobId: job.jobId,
            jobTitle: job.jobTitle,
            jobOpenDate: job.jobOpenDate,
            jobStatus: job.jobStatus,
            jobClosedAt: job.jobClosedAt,
            jobCloseReason: job.jobCloseReason,
            vacanciesTotal: job.vacanciesTotal,
            vacanciesFilled: job.vacanciesFilled,
            stages: jobStages,
          });
        });

        companyMap.forEach((v) => {
          const jobsForCompany = Array.isArray(v.openJobs) ? v.openJobs : [];
          jobsForCompany.sort((a, b) => {
            const at = new Date(a.jobOpenDate).getTime() || 0;
            const bt = new Date(b.jobOpenDate).getTime() || 0;
            if (bt !== at) return bt - at;
            return String(a.jobId || "").localeCompare(String(b.jobId || ""));
          });
          const maxJobs = 3;
          const available = Math.min(maxJobs, jobsForCompany.length);
          const pickCount =
            available <= 0
              ? 0
              : randInt(
                  `openJobs|limit|${dateKey}|${emp.id}|${v._id || v.id || ""}`,
                  1,
                  available,
                );
          v.openJobs = jobsForCompany.slice(0, pickCount);
          companies.push(v);
        });

        employeesForDay.push({
          _id: `emp_${emp.id}`,
          employeeId: emp.id,
          employeeName: emp.name,
          companies,
        });
      });
    }

    result.push({ date: current.toDate(), employees: employeesForDay });

    current = current.add(1, "day");
  }

  return result;
}

const demoAtsDataset = generateAtsDataset(employees, submissionStages);
const employeeSubmissions = generateDateWiseData(employees, submissionStages);
duration.dates = employeeSubmissions;

export {
  demoAtsDataset,
  employeeSubmissions,
  employees as demoEmployees,
  submissionStages as demoSubmissionStages,
};
